export default __webpack_public_path__ + "static/media/M16.c5289402.svg";